import React from "react";

function SummaryCard({ title, value }) {
  return (
    <div style={{
      padding: 20,
      background: "white",
      borderRadius: 10,
      boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
      flex: 1,
      margin: 10
    }}>
      <h4>{title}</h4>
      <h2>{value}</h2>
    </div>
  );
}

export default SummaryCard;
